exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".baseForm[data-v-23ee28b6] .el-input {\n  width: 250px !important;\n}\n", ""]);

// exports
